/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { createResize } from '../../factoriesAny.js';
export var resizeDependencies = {
  matrixDependencies,
  createResize
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesResize.generated.js
// module id = nXOr
// module chunks = 3